interface FractionalTime {
  hours: number;
  minutes: number;
  days: number;
}

export const minutesToFractional = (minutes: number): FractionalTime => {
  const days = Math.floor(minutes / (60 * 24));
  const remainingMinutesAfterDays = Math.ceil(minutes % (60 * 24));
  const hours = Math.floor(remainingMinutesAfterDays / 60);
  const remainingMinutesAfterHours = Number(remainingMinutesAfterDays.toFixed(0)) % 60;

  return {
    hours,
    minutes: remainingMinutesAfterHours,
    days,
  };
};

export const fractionalToMinutes = ({ hours, minutes, days }: FractionalTime) =>
  days * 60 * 24 + hours * 60 + minutes;
